import { createSelector } from 'reselect';

export const getAmbrs = state => state.ambrs;
export const isLoadingAmbrs = createSelector(getAmbrs, ambrs => ambrs.loading);
export const getAmbrsError = createSelector(getAmbrs, ambrs => ambrs.error);
export const getAmbrsItems = createSelector(getAmbrs, ambrs => ambrs.items);
export const getResentlyUpdated = createSelector(getAmbrs, ambrs => ambrs.resentlyUpdated);
